import styled from 'styled-components'

import ListItem from '../ListItem'

const MenuItem = styled(ListItem)`
  display: ${props => (props.hideOnMobile ? 'none' : 'flex')};

  ${props => (props.toggle ? 'padding: 0 !important;' : '')}

  @media (min-width: 768px) {
    display: flex;
  }
`

export default MenuItem
